import { BsStars } from "react-icons/bs"
import { FiX } from "react-icons/fi"

import useChatStream from "../../hooks/useChatStream"
import useChatWidget from "../../hooks/useChatWidget"

import { FABButton, UnreadBadge } from "./styles"

import ChatPanel from "./ChatPanel"

const ChatWidget = () => {
   const { isOpen, unreadCount, toggle, close } = useChatWidget()
   const { messages, isStreaming, error, tripData, sendMessage, stopStreaming, clearMessages, clearTripData } =
      useChatStream()

   return (
      <>
         {isOpen && (
            <ChatPanel
               messages={messages}
               isStreaming={isStreaming}
               error={error}
               tripData={tripData}
               onSend={sendMessage}
               onStop={stopStreaming}
               onClear={clearMessages}
               onClose={close}
               onTripFilled={() => {
                  clearTripData()
                  close()
               }}
            />
         )}
         <FABButton onClick={toggle} $hasUnread={!isOpen && unreadCount > 0} aria-label="Toggle chat assistant">
            {isOpen ? <FiX /> : <BsStars />}
            {!isOpen && unreadCount > 0 && <UnreadBadge>{unreadCount > 9 ? "9+" : unreadCount}</UnreadBadge>}
         </FABButton>
      </>
   )
}

export default ChatWidget
